import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

export interface LawyerRow {
  id: string;
  first_name: string;
  last_name: string;
  full_name: string | null;
  law_firm: string | null;
  address: string | null;
  phone: string | null;
  email: string | null;
  notes: string | null;
  is_active: boolean;
  created_at: number;
  updated_at: number;
}

export function useLawyers(activeOnly = true) {
  return useQuery({
    queryKey: ['lawyers', { activeOnly }] as const,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (activeOnly) params.set('active_only', 'true');
      const res = await apiFetch(`/lawyers?${params}`);
      if (!res.ok) throw new Error(`lawyers_list_failed_${res.status}`);
      const json = (await res.json()) as { items: LawyerRow[] };
      return json.items;
    },
    staleTime: 5 * 60_000,
  });
}

export function useCreateLawyer() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: {
      firstName: string;
      lastName: string;
      lawFirm?: string;
      phone?: string;
      email?: string;
      address?: string;
    }) => {
      const res = await apiFetch('/lawyers', {
        method: 'POST',
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error(`lawyer_create_failed_${res.status}`);
      return (await res.json()) as LawyerRow;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['lawyers'] }),
  });
}
